import React from "react";
import getConfig from "next/config";
import Link from "next/link";
import FullWidthSection from "../components/FullWidthSection";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const passions = [
  {
    img: "masini-si-vehicule",
    value: "masini_trenuri_vehicule",
  },
  {
    img: "casute",
    value: "casute",
  },
  {
    img: "cinema-si-supereroi",
    value: "cinema_super-eroi",
  },
  {
    img: "spatiu",
    value: "spatiu",
  },
  {
    img: "decor",
    value: "decor_arhitectura",
  },
  {
    img: "animale",
    value: "animale",
  },
  {
    img: "printese",
    value: "printese",
  },
  {
    img: "politie-si-pompieri",
    value: "politie_pompieri",
  },
  {
    img: "jocuri-video",
    value: "jocuri-video",
  },
  {
    img: "caramizi-variate",
    value: "caramizi-variate",
  },
];

const LegoByPassion = () => (
  <div className="">
    <div className="mb-8 sm:max-w-[60%] md:max-w-[35%] -ml-[8px]">
      <img
        src={`${settings.websiteStatics}/images/universul-lego/passion_title.png`}
        alt=""
      />
    </div>

    <FullWidthSection padding="p-0">
      <ul className="grid grid-rows-2 grid-flow-col overflow-x-scroll gap-4 px-4 md:grid-flow-row md:grid-rows-none md:grid-cols-4 lg:grid-cols-5">
        {passions.map(({ img, value }, index) => (
          <li key={index} className="w-40 sm:w-48 md:w-auto">
            <Link href={`/lego-jucarii/cpl/filtru/interese-9351/${value}/`}>
              <a title="">
                <img
                  src={`${settings.websiteStatics}/images/universul-lego/pasiune/${img}.png`}
                  alt=""
                />
              </a>
            </Link>
          </li>
        ))}
      </ul>
    </FullWidthSection>
  </div>
);

export default LegoByPassion;
